module.exports = __webpack_public_path__ + "img/user.efec17d9.svg";